import type {
  BatchGetModelsRequest,
  BatchGetModelsResponse,
  SendModelRequest,
  SendModelResponse,
} from '@blk/aladdin-graph-client-axios-internal/wealth/portfolio_management/models/v1/model_api';
import { awPortfolioManagementApi } from './Base';

const MODELS_PATH = 'models/v1/models';

export function postSendModels(request: SendModelRequest) {
  const path = `${MODELS_PATH}:send`;
  return awPortfolioManagementApi.post<SendModelResponse>(path, request);
}

export function postBatchGetModelsV2(getModelsRequest: BatchGetModelsRequest) {
  const path = `${MODELS_PATH}:batchGet`;
  return awPortfolioManagementApi.post<BatchGetModelsResponse>(path, getModelsRequest);
}
